import React from 'react';
import cn from 'classnames';
import { Checkbox } from "../../Checkbox";
import { Typography } from "../../Typography";
import styles from "./CheckboxWithLabel.module.scss";
export const CheckboxWithLabel = _ref => {
  let {
    id,
    label,
    sublabel,
    checked,
    testId,
    className,
    onChange
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.root, className),
    "data-testid": testId
  }, /*#__PURE__*/React.createElement(Checkbox, {
    id: id,
    "data-testid": "".concat(testId, "-checkbox"),
    onChange: onChange,
    checked: checked
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.label
  }, /*#__PURE__*/React.createElement(Typography, null, label), sublabel && /*#__PURE__*/React.createElement(Typography, {
    skin: "secondary"
  }, sublabel))));
};